module.exports = __webpack_public_path__ + "img/menu-04.c77520d7.svg";